import type { Technique } from '../types';
import { DOMAIN_WARP_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, toSVG, type DomainWarpState } from './render';

export const domainWarp: Technique<DomainWarpState> = {
  id: 'domain-warp',
  name: 'Domain Warping',
  category: 'noise',
  description: 'Verzerrt die Buchstabenform selbst mehrfach durch Rauschen.',
  params: DOMAIN_WARP_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  toSVG,
  elementCount,
};
